__turbopack_context__.v({
  "circle": "iconButton-module-scss-module__NKTPIq__circle",
  "ghost": "iconButton-module-scss-module__NKTPIq__ghost",
  "icon": "iconButton-module-scss-module__NKTPIq__icon",
  "iconButton": "iconButton-module-scss-module__NKTPIq__iconButton",
  "inverted": "iconButton-module-scss-module__NKTPIq__inverted",
  "muted": "iconButton-module-scss-module__NKTPIq__muted",
  "neutral": "iconButton-module-scss-module__NKTPIq__neutral",
  "primary": "iconButton-module-scss-module__NKTPIq__primary",
  "secondary": "iconButton-module-scss-module__NKTPIq__secondary",
  "tertiary": "iconButton-module-scss-module__NKTPIq__tertiary",
  "withoutPadding": "iconButton-module-scss-module__NKTPIq__withoutPadding",
});
